import React, { useState, useEffect } from "react";
import Web3 from "web3";
import { InjectedConnector } from "@web3-react/injected-connector";
import WalletConnectProvider from "@walletconnect/web3-provider";
import contractAbi from "./contractAbi";
import contractABIusdt from "./contractABIusdt";

import usdtLogo from "./images/usdt-logo.svg";
import bnbLogo from "./images/bnb-logo.svg";
import darkLogo from "./images/dark-logo.png";
import heroShape1 from "./images/hero-shape-1.svg";
import heroShape2 from "./images/hero-shape-2.svg";
import faqShape1 from "./images/faq-shape-1.svg";
import firstM from "./images/first.jpg";
import third from "./images/third.jpg";
import secondM from "./images/second.jpg";
import metamaskLogo from "./images/metamask-logo.png";
import trustLogo from "./images/trust-logo.png";
import logo from "./images/logo.png";
import lnone from "./images/ln-one.jpg";
import lntwo from "./images/ln-two.jpg";
import lnthree from "./images/ln-three.jpg";
import lnfour from "./images/ln-four.jpg";
import uaone from "./images/au-one.jpg";
import uatwo from "./images/au-two.jpg";
import uathree from "./images/au-three.jpg";
import uafour from "./images/au-four.jpg";
import contactus from "./images/contact-us.jpg";

import { EthereumProvider } from "@walletconnect/ethereum-provider";

import { Buffer } from "buffer";
import process from "process";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

window.Buffer = Buffer;
window.process = process;

const injected = new InjectedConnector({
    supportedChainIds: [56],
});

const projectId = "e5281020f06c838ec5f72b380f8b5306";

const metadata = {
    name: "CASHERPresale",
    description:
        " I am Casher, short for Cash Reserve. I am a new and ambitious project in the field of DeFi currencies.",
    //url: 'https://reown.com/appkit',
    url: "https://cashreservecasher.com",
    //icons: ['https://assets.reown.com/reown-profile-pic.png']
    icons: ["https://cashreservecasher.com/images/logo.png"],
};

function App() {
    const navRef = React.useRef(null);
    const backTopRef = React.useRef(null);
    const [web3, setWeb3] = useState(null);
    const [account, setAccount] = useState(null);
    const [tokenPrice, setTokenPrice] = useState(null);
    const [bnbTokenPrice, setBnbTokenPrice] = useState(null);
    const [usdtToken, setUsdtToken] = useState(null);
    const [contract, setContract] = useState(null);
    const [coinType, setCoinType] = useState("USDT");

    const [price, setPrice] = useState(0);
    const [usdt, setUsdt] = useState(1);
    const [dogs, setDogs] = useState(0);
    const [dataType, setDataType] = useState(1);
    const [ConnectWalletString, setConnectWalletString] =
        useState("Connect Wallet");
    const [navM, setNavM] = useState(true);
    const [providerClient, setProviderClient] = useState(undefined);
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    useEffect(() => {
        const initWeb3 = async () => {
            const provider = new Web3.providers.HttpProvider(
                "https://bsc-dataseed.binance.org/",
            );
            const web3Instance = new Web3(provider);
            setWeb3(web3Instance);
        };
        initWeb3();
        if (isMobile && !providerClient) {
            onInitializeProviderClient();
        }
    }, []);

    const onInitializeProviderClient = async () => {
        try {
            const client = await EthereumProvider.init({
                projectId,
                showQrModal: true,
                qrModalOptions: { themeMode: "light" },
                chains: [56],
                methods: ["eth_sendTransaction", "personal_sign"],
                events: ["chainChanged", "accountsChanged"],
                metadata,
            });
            console.log("client", client);
            setProviderClient(client);

            client.on("connect", params => {
                console.log("connected", params);
            });

            client.on("disconnect", params => {
                console.log("disconnected", params);
            });
        } catch (error) {
            console.error("Failed to initialize provider client", error);
            toast.error("Failed to initialize provider client");
        }
    };

    const copyToClipboard = () => {
        navigator.clipboard
            .writeText(contractAddress)
            .then(() => {
                toast.success("Address copied to clipboard!");
            })
            .catch(err => {
                console.error("Could not copy text: ", err);
            });
    };
    useEffect(() => {
        const handleScroll = () => {
            if (navRef.current) {
                navRef.current.classList.toggle(
                    "active-nav",
                    window.scrollY > 150,
                );
            }
            if (backTopRef.current) {
                backTopRef.current.classList.toggle(
                    "hidden",
                    window.scrollY < 300,
                );
            }

            const openMenu = document.querySelector(".res-menu-open");
            const closeMenu = document.querySelector(".res-menu-close");
            const resMenu = document.querySelector(".responsive-menu");
            const resMenuTwo = document.querySelector(".responsive-menu-two");
            const openMenuTwo = document.querySelector(".res-menu-open-two");
            const closeMenuTwo = document.querySelector(".res-menu-close-two");

            openMenu.classList.remove("hidden");
            closeMenu.classList.add("hidden");
            resMenu.classList.replace("flex", "hidden");
            openMenuTwo.classList.remove("hidden");
            closeMenuTwo.classList.add("hidden");
            resMenuTwo.classList.replace("flex", "hidden");
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const contractAddress = "0x25c6CC8513c87cF43f0d6A953D1300eF1b693055";
    const usdtAddress = "0x55d398326f99059ff775485246999027b3197955";

    const getSecondsUntilMidnight = () => {
        const now = new Date();
        const midnight = new Date(now);
        midnight.setHours(24, 0, 0, 0);
        const diff = midnight - now;
        return Math.floor(diff / 1000);
    };
    const [time, setTime] = useState(getSecondsUntilMidnight());
    useEffect(() => {
        const intervalId = setInterval(() => {
            setTime(prevTime => {
                if (prevTime <= 1) {
                    clearInterval(intervalId);
                    return 0;
                }
                return prevTime - 1;
            });
        }, 1000);

        return () => clearInterval(intervalId);
    }, []);
    const formatTime = seconds => {
        const hrs = Math.floor(seconds / 3600);
        const mins = Math.floor((seconds % 3600) / 60);
        const secs = seconds % 60;
        return `${hrs.toString().padStart(2, "0")}:${mins
            .toString()
            .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
    };

    useEffect(() => {
        if (web3) {
            interactWithContract();
        }
    }, [web3]);
    const funNavM = () => {
        setNavM(p => !p);
    };

    const openMenu = document.querySelector(".res-menu-open");
    const closeMenu = document.querySelector(".res-menu-close");
    const openMenuTwo = document.querySelector(".res-menu-open-two");
    const closeMenuTwo = document.querySelector(".res-menu-close-two");
    const resMenu = document.querySelector(".responsive-menu");
    const resMenuTwo = document.querySelector(".responsive-menu-two");

    const openMenuTwoFun = () => {
        resMenu.classList.replace("hidden", "flex");
        openMenu.classList.add("hidden");
        closeMenu.classList.remove("hidden");
        closeMenuTwo.classList.replace("hidden", "flex");
        openMenuTwo.classList.add("hidden");
        resMenuTwo.classList.replace("flex", "hidden");
    };

    const closeMenuTwoFun = () => {
        resMenu.classList.replace("flex", "hidden");
        openMenu.classList.remove("hidden");
        closeMenu.classList.add("hidden");
        openMenuTwo.classList.replace("hidden", "flex");
        closeMenuTwo.classList.add("hidden");
    };

    const calculateTokensFromUSDT = event => {
        const value = event.target.value;
        const usdtAmountNumber = parseFloat(value);

        setUsdt(value);

        if (
            isNaN(usdtAmountNumber) ||
            usdtAmountNumber.toString() !== value.trim() ||
            usdtAmountNumber <= 0
        ) {
            setDogs(0);
            return;
        }

        if (dataType) {
            if (usdtAmountNumber && tokenPrice) {
                const tokens =
                    BigInt(Math.floor(usdtAmountNumber * 1e18)) /
                    BigInt(tokenPrice);

                setDogs(Math.floor(Number(tokens)));
            }
        } else {
            if (usdtAmountNumber && bnbTokenPrice) {
                const tokens =
                    BigInt(Math.floor(usdtAmountNumber * 1e18)) /
                    BigInt(bnbTokenPrice);
                setDogs(Math.floor(Number(tokens)));
            }
        }
    };

    const calculateTokens = value => {
        const WEI_MULTIPLIER_6 = BigInt(1e18);
        const WEI_MULTIPLIER_18 = BigInt(1e18);

        if (dataType) {
            if (value && tokenPrice) {
                return (
                    (BigInt(web3.utils.toWei(value.toString(), "ether")) *
                        WEI_MULTIPLIER_6) /
                    BigInt(tokenPrice)
                );
            }
        } else {
            if (value && bnbTokenPrice) {
                return (
                    (BigInt(web3.utils.toWei(value.toString(), "ether")) *
                        WEI_MULTIPLIER_18) /
                    BigInt(bnbTokenPrice)
                );
            }
        }
        return BigInt(0);
    };

    const DOMContentLoaded = value => {
        if (value == 1 && dataType !== 1) {
            setDataType(1);
            setCoinType("USDT");
            setUsdt(1);
            const valueM = BigInt(web3.utils.toWei("1", "ether"));
            const tokens = (valueM * BigInt(1e18)) / tokenPrice;

            setPrice(
                Number(web3.utils.fromWei(tokens.toString(), "ether")).toFixed(
                    2,
                ),
            );
            setDogs(
                Math.floor(
                    Number(web3.utils.fromWei(tokens.toString(), "ether")),
                ),
            );
        } else if (value == 0 && dataType !== 0) {
            setDataType(0);
            setCoinType("BNB");
            setUsdt(1);
            const valueM = BigInt(web3.utils.toWei("1", "ether"));
            const tokens = (valueM * BigInt(1e18)) / bnbTokenPrice;

            setPrice(
                Number(web3.utils.fromWei(tokens.toString(), "ether")).toFixed(
                    2,
                ),
            );
            setDogs(
                Math.floor(
                    Number(web3.utils.fromWei(tokens.toString(), "ether")),
                ),
            );
        }
    };
    const connectWallet = async () => {
        if (isMobile) {
            if (!providerClient) {
                return false;
            }
            try {
                setConnectWalletString("Loading...");

                await providerClient.connect();

                await new Promise(resolve => setTimeout(resolve, 1000));
                const web3Instance = new Web3(providerClient);

                setWeb3(web3Instance);

                const accounts = await web3Instance.eth.getAccounts();
                setAccount(accounts[0]);
                const accountAddress = accounts[0];
                const accountSlice =
                    accountAddress.slice(0, 6) +
                    "..." +
                    accountAddress.slice(-4);
                setConnectWalletString(accountSlice);
                toast.success(`Connected account: ${accounts[0]}`);
            } catch (error) {
                setConnectWalletString("Connect Wallet");
                console.error("Failed to connect to wallet", error);
                toast.error("Failed to connect to wallet");
            }
        } else {
            let provider;
            try {
                await injected.activate();
                provider = window.ethereum;
                if (provider.networkVersion !== "56") {
                    try {
                        await provider.request({
                            method: "wallet_switchEthereumChain",
                            params: [{ chainId: "0x38" }],
                        });
                    } catch (switchError) {
                        if (switchError.code === 4902) {
                            try {
                                await provider.request({
                                    method: "wallet_addEthereumChain",
                                    params: [
                                        {
                                            chainId: "0x38",
                                            chainName: "Binance Smart Chain",
                                            rpcUrls: [
                                                "https://bsc-dataseed.binance.org/",
                                            ],
                                            nativeCurrency: {
                                                name: "BNB",
                                                symbol: "BNB",
                                                decimals: 18,
                                            },
                                            blockExplorerUrls: [
                                                "https://bscscan.com",
                                            ],
                                        },
                                    ],
                                });
                            } catch (addError) {
                                console.error(
                                    "Failed to add the network to Metamask",
                                    addError,
                                );
                                toast.error(
                                    "Failed to add the network to Metamask",
                                );
                            }
                        } else {
                            console.error(
                                "Failed to switch to the network",
                                switchError,
                            );
                            toast.error("Failed to switch to the network");
                        }
                    }
                }
                if (!provider) {
                    throw new Error(
                        "Provider not available. Please ensure that Metamask is installed and configured correctly.",
                    );
                }
                // const web3Instance = new Web3(provider);
                // setWeb3(web3Instance);
                // const accounts = await web3Instance.eth.getAccounts();
                // setAccount(accounts[0]);
                // const accountsSlice =
                //     accounts.slice(0, 6) + "..." + accounts.slice(-4);
                // setConnectWalletString(accountsSlice);

                const web3Instance = new Web3(provider);
                setWeb3(web3Instance);
                const accounts = await web3Instance.eth.getAccounts();
                setAccount(accounts[0]);
                const accountAddress = accounts[0];
                const accountSlice =
                    accountAddress.slice(0, 6) +
                    "..." +
                    accountAddress.slice(-4);
                setConnectWalletString(accountSlice);
                toast.success(`Connected account: ${accounts[0]}`);
            } catch (error) {
                console.error("Failed to connect to wallet", error);
                toast.error("Failed to connect to wallet");
            }
        }
    };

    const interactWithContract = async () => {
        if (!web3) {
            console.error("Web3 is not initialized");
            return;
        }

        const contractInstance = new web3.eth.Contract(
            contractAbi,
            contractAddress,
        );
        const usdtTokenInstance = new web3.eth.Contract(
            contractABIusdt,
            usdtAddress,
        );

        const tokenPriceValue = BigInt(
            await contractInstance.methods.tokenPrice().call(),
        );
        const bnbTokenPriceValue = BigInt(
            await contractInstance.methods.bnbTokenPrice().call(),
        );

        const value = BigInt(web3.utils.toWei("1", "ether"));
        const tokens = (value * BigInt(1e18)) / tokenPriceValue;

        setTokenPrice(tokenPriceValue);
        setBnbTokenPrice(bnbTokenPriceValue);
        setPrice(web3.utils.fromWei(tokens.toString(), "ether"));
        setDogs(
            Math.floor(Number(web3.utils.fromWei(tokens.toString(), "ether"))),
        );
        setUsdtToken(usdtTokenInstance);
        setContract(contractInstance);
    };

    const FunBuy = async () => {
        if (!account) {
            return;
        }

        const usdtAmount = usdt;
        if (contract && usdtAmount > 0) {
            const inTransaction = await contract.methods.inTransaction().call();

            if (inTransaction) {
                toast.success(
                    "A transaction is already in progress. Please try again later.",
                );
                return;
            }

            if (dataType) {
                const value = BigInt(Math.floor(usdtAmount * 1e18));
                try {
                    await usdtToken.methods
                        .approve(contractAddress, value.toString())
                        .send({ from: account });
                    toast.success(
                        "Step 1: Approval Successful! Your USDT approval transaction has been completed successfully. To finalize your token purchase, please open your wallet and confirm the second transaction. This will ensure that the tokens are transferred to your account seamlessly. Thank you!",
                    );

                    await contract.methods
                        .buyTokens(value.toString())
                        .send({ from: account, gas: 300000 });

                    toast.success("Successfully bought tokens with USDT!");
                } catch (error) {
                    toast.error("Error buying tokens with USDT!");
                }
            } else {
                const bnbAmount = web3.utils.toWei(
                    usdtAmount.toString(),
                    "ether",
                );
                try {
                    await contract.methods.buyTokensWithBNB().send({
                        from: account,
                        value: bnbAmount,
                        gas: 300000,
                    });
                    toast.success("Successfully bought tokens with BNB!");
                } catch (error) {
                    toast.error("Error buying tokens with BNB!");
                }
            }
        }
    };

    return (
        <>
            <div id="walletPopup" className="popup">
                <div className="popup-content flex flex-col items-end">
                    <span
                        className="close font-bold text-2xl flex justify-center items-center"
                        onclick="closePopup()"
                    >
                        &times;
                    </span>
                    <div className="popup-btns flex justify-around items-center w-full gap-5">
                        <button
                            onclick="connectMetaMask()"
                            className="flex w-full justify-center items-center"
                        >
                            MetaMask
                            <img src={metamaskLogo} className="wallet-logo" />
                        </button>
                        <button
                            onclick="connectTrustWallet()"
                            className="flex w-full justify-center items-center"
                        >
                            Trust Wallet
                            <img src={trustLogo} className="wallet-logo" />
                        </button>
                    </div>
                </div>
            </div>

            <div className="flex flex-col justify-center items-center mx-auto relative">
                <div className="connect-wallet-section bg-white hidden flex-col justify-center items-center">
                    <i className="ri-close-line close-connect-wallet"></i>
                    <p className="connect-wallet-error">
                        Please connect your wallet!
                    </p>
                </div>

                <header
                    id="home"
                    className="header w-full flex flex-col relative z-50"
                >
                    <nav
                        id="nav"
                        className="nav w-full mx-auto p-5 flex text-gray z-50"
                    >
                        <div className="logo flex justify-start items-center">
                            <a href="/">
                                <img src={logo} className="logo-image" />
                            </a>
                        </div>

                        <div className="menu hidden lg:block mx-auto">
                            <ul className="nav-menu flex list-none h-full items-center 0 justify-center gap-5 w-full">
                                <li>
                                    <a href="#">Home</a>
                                </li>
                                <li>
                                    <a href="#latest-news">Latest news</a>
                                </li>
                                <li>
                                    <a href="#about-us">About us</a>
                                </li>
                                <li>
                                    <a href="#how-it-works">How it works</a>
                                </li>
                                <li>
                                    <a href="#tokenomics">Tokenomics</a>
                                </li>
                                <li>
                                    <a href="#roadmap">Roadmap</a>
                                </li>
                                <li>
                                    <a
                                        href="https://cashreservecasher.com/CashReserve-whitepaper.pdf"
                                        target="_blank"
                                    >
                                        White paper
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <div
                            className={`responsive-menu flex-col justify-center items-center w-3/2 lg:w-1/2 right-10 top-20 bg-purple text-light-brown p-10 rounded-lg z-50 ${
                                navM ? "hidden" : "flex"
                            }`}
                        >
                            <ul className="flex flex-col list-none h-full items-center justify-center gap-5">
                                <li>
                                    <a href="#">Home</a>
                                </li>
                                <li>
                                    <a href="#latest-news">Latest news</a>
                                </li>
                                <li>
                                    <a href="#about-us">About us</a>
                                </li>
                                <li>
                                    <a href="#how-it-works">How it works</a>
                                </li>
                                <li>
                                    <a href="#tokenomics">Tokenomics</a>
                                </li>
                                <li>
                                    <a href="#roadmap">Roadmap</a>
                                </li>
                                <li>
                                    <a
                                        href="https://cashreservecasher.com/CashReserve-whitepaper.pdf"
                                        target="_blank"
                                    >
                                        White paper
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <div className="flex lg:hidden justify-end w-full">
                            <button
                                className="res-menu-btn lg:hidden w-1/12 flex justify-end items-center"
                                onClick={() => {
                                    funNavM();
                                }}
                            >
                                <i
                                    className={`res-menu-open ri-menu-line text-3xl font-semibold ${
                                        !navM && "hidden"
                                    }`}
                                ></i>

                                <i
                                    className={`ri-close-line res-menu-close text-3xl font-semibold ${
                                        navM && "hidden"
                                    }`}
                                ></i>
                            </button>
                        </div>
                    </nav>

                    <nav
                        ref={navRef}
                        id="nav-two"
                        className="nav nav-two flex nav-two w-full mx-auto p-5 text-gray z-50 fixed"
                    >
                        <div className="logo flex justify-start items-center">
                            <a href="/">
                                <img src={logo} className="logo-image" />
                            </a>
                        </div>

                        <div className="menu hidden lg:block mx-auto">
                            <ul className="nav-menu flex list-none h-full items-center 0 justify-center gap-5 w-full">
                                <li>
                                    <a href="#">Home</a>
                                </li>
                                <li>
                                    <a href="#latest-news">Latest news</a>
                                </li>
                                <li>
                                    <a href="#about-us">About us</a>
                                </li>
                                <li>
                                    <a href="#how-it-works">How it works</a>
                                </li>
                                <li>
                                    <a href="#tokenomics">Tokenomics</a>
                                </li>
                                <li>
                                    <a href="#roadmap">Roadmap</a>
                                </li>
                                <li>
                                    <a
                                        href="https://cashreservecasher.com/CashReserve-whitepaper.pdf"
                                        target="_blank"
                                    >
                                        White paper
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <div
                            id="responsive-menu-two"
                            className="responsive-menu-two flex-col justify-center items-center w-3/2 lg:w-1/2 right-10 top-20 bg-purple text-light-brown p-10 rounded-lg z-50 hidden"
                        >
                            <ul className="flex flex-col list-none h-full items-center justify-center gap-5">
                                <li>
                                    <a href="#">Home</a>
                                </li>
                                <li>
                                    <a href="#latest-news">Latest news</a>
                                </li>
                                <li>
                                    <a href="#about-us">About us</a>
                                </li>
                                <li>
                                    <a href="#how-it-works">How it works</a>
                                </li>
                                <li>
                                    <a href="#tokenomics">Tokenomics</a>
                                </li>
                                <li>
                                    <a href="#roadmap">Roadmap</a>
                                </li>
                                <li>
                                    <a
                                        href="https://cashreservecasher.com/CashReserve-whitepaper.pdf"
                                        target="_blank"
                                    >
                                        White paper
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <div className="flex lg:hidden justify-end w-full">
                            <button className="res-menu-btn-two lg:hidden w-1/12 flex justify-end items-center">
                                <i
                                    className="res-menu-open-two ri-menu-line text-3xl font-semibold"
                                    onClick={() => {
                                        openMenuTwoFun();
                                    }}
                                ></i>

                                <i
                                    className="ri-close-line res-menu-close-two hidden text-3xl font-semibold"
                                    onClick={() => {
                                        closeMenuTwoFun();
                                    }}
                                ></i>
                            </button>
                        </div>
                    </nav>

                    <section className="header-main w-full flex flex-col-reverse items-center z-40 lg:flex-row justify-between">
                        <div className="header-socials socials text-2xl flex flex-col gap-5 p-text">
                            <a
                                href="https://x.com/CASHER_CR?t=r2nTJjmF8xvvekhYh2Pd3w&s=09"
                                target="_blank"
                            >
                                <i className="ri-twitter-x-line twitter"></i>
                            </a>
                            <a
                                href="https://www.instagram.com/cashreserve_casher?igsh=aTVscjlzbjIyaXJ2"
                                target="_blank"
                            >
                                <i className="ri-instagram-line instagram"></i>
                            </a>
                            <a
                                href="https://t.me/cashreservecoin"
                                target="_blank"
                            >
                                <i className="ri-telegram-2-line telegram"></i>
                            </a>
                        </div>

                        <div className="presale flex flex-col items-center justify-center z-40">
                            <h3 className="p-text text-xl sm:text-xl lg:text-4xl mx-auto bg">
                                CASHER
                                <span className="g-text">Presale</span>
                            </h3>

                            <p className="header-main-caption text-xl mt-10 font-bold">
                                Until next price increase
                            </p>

                            <p id="timer" className="timer p-text text-2xl">
                                {formatTime(time)}
                            </p>
                            <button
                                id="connectBtn"
                                className="connectBtn buy-link connect-wallet-btn"
                                onClick={() => connectWallet()}
                            >
                                <div className="_button__content_ms3tu_71">
                                    {isMobile && !providerClient
                                        ? "Loading..."
                                        : ConnectWalletString}
                                </div>
                            </button>

                            <div className="button-container flex flex-col justify-center items-center">
                                <div className="flex font-bold">
                                    <h2>
                                        1{" "}
                                        <span className="coin">
                                            {coinType}{" "}
                                        </span>
                                    </h2>
                                    =
                                    <h1 style={{ color: "black" }}>
                                        <span id="price">
                                            {" "}
                                            {Math.floor(price)}
                                        </span>{" "}
                                        CASHER Token
                                    </h1>
                                </div>
                                <div className="flex gap-5">
                                    <button
                                        type="button"
                                        className={`buy-link pay-with-usdt flex justify-center items-center gap-3 ${
                                            dataType && "active-m"
                                        }`}
                                        onClick={() => DOMContentLoaded(1)}
                                    >
                                        Choose USDT
                                        <img
                                            src={usdtLogo}
                                            alt="USDT Logo"
                                            className="coin-logo"
                                        />
                                    </button>
                                    <button
                                        type="button"
                                        className={`buy-link pay-with-bnb flex justify-center items-center gap-3 ${
                                            !dataType && "active-m"
                                        }`}
                                        onClick={() => DOMContentLoaded(0)}
                                    >
                                        Choose BNB
                                        <img
                                            src={bnbLogo}
                                            alt="BNB Logo"
                                            className="coin-logo"
                                        />
                                    </button>
                                </div>
                            </div>
                            <div className="flex justify-center items-center">
                                <div className="undefined">
                                    <p className="p-text mt-5">
                                        Pay with{" "}
                                        <span className="coin p-text">
                                            {" "}
                                            {coinType}
                                        </span>
                                    </p>
                                    <div className="relative flex justify-center items-center">
                                        <input
                                            className="btn-one btn-two"
                                            type="text"
                                            min="0"
                                            onChange={calculateTokensFromUSDT}
                                            value={usdt}
                                        />
                                        <div className="coin-logo-section">
                                            {dataType ? (
                                                <img
                                                    src={usdtLogo}
                                                    alt="USDT Logo"
                                                    className="usdt-logo coin-logo"
                                                />
                                            ) : (
                                                <img
                                                    src={bnbLogo}
                                                    alt="BNB Logo"
                                                    className="bnb-logo coin-logo"
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="undefined">
                                    <p className="p-text mt-5">
                                        CASHER You receive
                                    </p>
                                    <div className="relative flex justify-center items-center">
                                        <label
                                            id="dogs"
                                            className="btn-one btn-two flex justify-center items-center"
                                        >
                                            {dogs}
                                        </label>
                                        <img
                                            src={darkLogo}
                                            alt="Dark Logo"
                                            className="dark-logo"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="div-buy">
                                <button
                                    className="buy-link connect-wallet-btn mt-10 active-m"
                                    onClick={() => FunBuy()}
                                >
                                    <div className="_button__content_ms3tu_71 ">
                                        Buy
                                    </div>
                                </button>
                            </div>
                        </div>

                        <div className="header-main-right w-3/8 flex flex-col justify-center items-center">
                            <h3 className="header-main-text p-text text-lg sm:text-xl lg:text-3xl mx-auto">
                                Welcome to
                                <span className="g-text">CASH RESERVE</span>
                            </h3>

                            <p className="header-main-caption w-3/4 text-center text-gray text-xl pt-5 flex justify-center items-center font-semibold">
                                Hi. Are you ready for a new redefinition in the
                                field of DeFi and investment? Let's start
                                together. I am Casher, short for Cash Reserve. I
                                am a new and ambitious project in the field of
                                DeFi currencies. A purposeful, secure,
                                intelligent, and scalable project with a strong
                                and experienced development team. My activities
                                will begin with the start of the presale. You
                                will hear good and brilliant news from me in the
                                future. Let's go! 🚀
                            </p>

                            <div className="header-btns w-full justify-center items-center gap-5 mt-10">
                                <button
                                    id="copy-contract"
                                    className="buy-link text-center"
                                    onClick={copyToClipboard}
                                >
                                    Copy contract
                                </button>

                                <a
                                    href="https://bscscan.com/address/0x25c6cc8513c87cf43f0d6a953d1300ef1b693055"
                                    className="buy-link text-center"
                                    target="_blank"
                                >
                                    Casher in BSCSCAN
                                </a>
                            </div>
                        </div>
                    </section>

                    <img
                        src={heroShape1}
                        className="header-image-one absolute z-0"
                    />
                    <img
                        src={heroShape2}
                        className="header-image-two absolute right-0 bottom-0 z-0"
                    />

                    <a
                        ref={backTopRef}
                        href="#"
                        className="back-top text-center hidden justify-center items-center absolute"
                    >
                        <i className="ri-arrow-up-line"></i>
                    </a>
                </header>

                <section
                    id="latest-news"
                    className="latest-news relative flex flex-col w-full pt-10"
                >
                    <div className="sections-top-text ln-text flex flex-col justify-center items-center z-40 mb-5">
                        <h1 className="text-2xl md:text-3xl p-text">
                            Latest news
                        </h1>
                    </div>

                    <div
                        id="ln-main"
                        className="ln-main relative w-full p-5 grid gap-5 text-gray-dark"
                    >
                        <img
                            src={faqShape1}
                            className="absolute top-0 right-0 left-0 bottom-0"
                        />
                        <div className="ln-left bg-gray-light rounded-lg overflow-hidden z-40">
                            <div>
                                <img src={lnone} className="w-full h-80" />
                            </div>

                            <div className="flex flex-col p-10">
                                <h1 className="text-lg font-bold my-3">
                                    Happy new year 🎉
                                </h1>

                                <div className="scroll-news">
                                    <p className="font-semibold">
                                        I hope you have had a great Christmas
                                        and holidays so far. Starting in 2025,
                                        we have decided to launch the digital
                                        currency Cash Reserve and aim to
                                        establish a strong position in the
                                        cryptocurrency world. I have highly
                                        strong and achievable goals in my future
                                        plans.
                                        <br />
                                        Are you ready? Let's go!
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="ln-left bg-gray-light rounded-lg overflow-hidden z-40">
                            <div>
                                <img src={lntwo} className="w-full h-80" />
                            </div>

                            <div className="flex flex-col p-10">
                                <h1 className="text-lg font-bold my-3">
                                    ✨Welcome to our DeFi community!✨
                                </h1>

                                <div className="scroll-news">
                                    <p className="font-semibold">
                                        We are proud to announce the launch of
                                        our new DeFi project! 😎🌐🚀🚀🚀💵💵💵😍
                                        <br />
                                        You will enter the world of financial
                                        innovations with us and share in our
                                        unique story in the developing future
                                        that is clearly mentioned in our goals,
                                        experience financial excitement, create
                                        a large financial reserve for yourself.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="ln-bottom bg-gray-light rounded-lg overflow-hidden z-40">
                            <div>
                                <img src={lnthree} className="w-full h-80" />
                            </div>

                            <div className="flex flex-col p-10">
                                <h1 className="text-lg font-bold my-3">
                                    Why Cash Reserve?
                                </h1>

                                <div className="scroll-news">
                                    <p className="font-semibold">
                                        By purchasing Casher currency and
                                        storing it, you can create a growing
                                        financial reserve for yourself, which
                                        you can use with high security and speed
                                        in the shortest possible time. Create a
                                        large treasure in your wallet called
                                        Cash Reserve. We intend to create a
                                        large liquidity reserve pool.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="ln-right bg-gray-light rounded-lg overflow-hidden z-40">
                            <div>
                                <img src={lnfour} className="w-full h-80" />
                            </div>

                            <div className="flex flex-col p-10">
                                <h1 className="text-lg font-bold my-3">
                                    Start of PreSale
                                </h1>

                                <div className="scroll-news">
                                    <p className="font-semibold">
                                        We have started the presale of Cash
                                        Reserve currency at a base price of
                                        0.0006, and this presale will continue
                                        for two months up to 10% of the total
                                        tokens produced. The token price will be
                                        updated every 24 hours based on the
                                        collected liquidity pool. The goal of
                                        the Casher project in the first year is
                                        1/1 USDT.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section
                    id="about-us"
                    className="aboutus w-full flex-col justify-around flex mt-20"
                >
                    <div className="sections-top-text flex w-full justify-center flex-col items-center mb-5">
                        <h1 className="text-xl md:text-2xl p-text">About us</h1>
                    </div>

                    <div className="w-full flex flex-col-reverse lg:flex-row lg:p-5 justify-center items-center">
                        <div className="about-us about-us-left w-full flex flex-col justify-center p-5 items-center md:w-1/2 lg:justify-start lg:items-start">
                            <h1 className="font-fair font-bold text-2xl w-2/3 sm:w-3/3 p-text text-center lg:text-start">
                                Our team aims to:
                            </h1>
                            <p className="mt-5 text-gray text-center lg:text-start font-semibold">
                                My development team pursues extremely strong,
                                ambitious, and achievable goals. Our goal is to
                                use Casher's capabilities to create a secure and
                                fast gateway to facilitate financial
                                transactions in real industries, between
                                individuals and organizations.
                            </p>
                        </div>

                        <div className="w-5/6 lg:w-1/3 about-us-right">
                            <img
                                src={uaone}
                                className="w-full h-full mx-auto aboutus-image"
                            />
                        </div>
                    </div>

                    <div className="w-full flex flex-col lg:flex-row lg:p-5 justify-center items-center">
                        <div className="w-5/6 lg:w-1/3 about-us-right">
                            <img
                                src={uatwo}
                                className="w-full h-full mx-auto aboutus-image"
                            />
                        </div>

                        <div className="about-us about-us-left w-full flex flex-col justify-center p-5 items-center md:w-1/2 lg:justify-start lg:items-start">
                            <h1 className="font-fair font-bold text-2xl w-2/3 sm:w-3/3 p-text text-center lg:text-start">
                                One of our important
                                <span className="g-text">goals:</span>
                            </h1>
                            <p className="mt-5 text-gray text-center lg:text-start font-semibold">
                                Cash Reserve is aimed at creating a large,
                                secure, and fast financial deposit and lending
                                fund where individuals of all financial
                                capacities can participate. By utilizing the BSC
                                network, we have significantly reduced our
                                costs. We intend to lend to knowledge-based
                                industries with achievable scientific goals and
                                become shareholders in those industries. This is
                                a win-win deal for both my community of holders
                                and the scientific industries.
                            </p>
                        </div>
                    </div>

                    <div className="w-full flex flex-col-reverse lg:flex-row lg:p-5 justify-center items-center">
                        <div className="about-us about-us-left w-full flex flex-col justify-center p-5 items-center md:w-1/2 lg:justify-start lg:items-start">
                            <h1 className="font-fair font-bold text-2xl w-2/3 sm:w-3/3 p-text text-center lg:text-start">
                                Cash Reserve Exchange
                                <span className="g-text">Bridge:</span>
                            </h1>
                            <p className="mt-5 text-gray text-center lg:text-start font-semibold">
                                In the future, we will create a system or bridge
                                as a direct payment gateway for all Cash Reserve
                                holders, with very low-cost and secure
                                transactions, allowing our community to easily
                                conduct exchanges. Additionally, it will be
                                possible to easily convert Casher to traditional
                                currencies and vice versa. 🌟💳💱
                            </p>
                        </div>

                        <div className="w-5/6 lg:w-1/3 about-us-image">
                            <img
                                src={uathree}
                                className="w-full h-full mx-auto aboutus-image"
                            />
                        </div>
                    </div>

                    <div className="w-full flex flex-col lg:flex-row lg:p-5 justify-center items-center">
                        <div className="w-5/6 lg:w-1/3 about-us-right">
                            <img
                                src={uafour}
                                className="w-full h-full mx-auto aboutus-image"
                            />
                        </div>

                        <div className="about-us about-us-left w-full flex flex-col justify-center p-5 items-center md:w-1/2 lg:justify-start lg:items-start">
                            <h1 className="font-fair font-bold text-2xl w-2/3 sm:w-3/3 p-text text-center lg:text-start">
                                Application and Commitment of
                                <span className="g-text">Cash Reserve</span>
                            </h1>
                            <p className="mt-5 text-gray text-center lg:text-start font-semibold">
                                Today, there is a strong connection between the
                                world of digital currencies and their practical
                                use in the science and research industry. We are
                                committed to this mission and aim to be pioneers
                                in this endeavor. 🌟🔬⚙️🧪📈
                            </p>
                        </div>
                    </div>

                    <div className="about-us-left w-full flex flex-col-reverse lg:flex-row justify-center items-center">
                        <div className="about-us w-1/2 flex flex-col justify-start my-5 items-center">
                            <div className="flex about-us-right flex-col w-3/4 justify-center lg:items-start items-center">
                                <h1 className="font-fair font-bold text-2xl w-full sm:w-3/3 text-center lg:text-start p-text">
                                    Contact us
                                </h1>
                                <p className="mt-5 text-gray text-center w-full justify-center lg:items-start items-center lg:justify-start font-semibold">
                                    For contact us you can send email:
                                </p>
                                <a
                                    href="mailto:casher.cashreserve@gmail.com"
                                    className="btn-one"
                                >
                                    Send mail
                                </a>
                            </div>
                        </div>

                        <div className="w-5/6 lg:w-1/3">
                            <img
                                src={contactus}
                                className="w-full h-full mx-auto aboutus-image"
                            />
                        </div>
                    </div>
                </section>

                <section
                    id="how-it-works"
                    className="how-it-works flex flex-col justify-center items-center py-5"
                >
                    <div className="sections-top-text flex w-full justify-center flex-col items-center mb-5">
                        <h1 className="text-2xl md:text-3xl p-text">
                            How it works
                        </h1>
                    </div>

                    <div className="cards-section grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4 gap-5 px-10">
                        <div className="how-it-works-left card flex flex-col justify-around items-center bg-gray-dark h-72 rounded-xl">
                            <i className="ri-bnb-fill text-3x lg:text-4xl my-3"></i>

                            <div className="card-text flex flex-col justify-center items-center">
                                <h1 className="head-text p-text text-xl font-bold">
                                    BlockChain
                                </h1>
                                <p className="description items-center text-gray-dark p-5 flex justify-center w-full text-center text-sm lg:text-base font-semibold">
                                    With the launch of Cash Reserve on the BNB
                                    blockchain, we have prioritized high
                                    security, fast transactions, and low costs
                                    from the very beginning. 🌐🔐
                                </p>
                            </div>
                        </div>

                        <div className="how-it-works-top card flex flex-col justify-around items-center bg-gray-dark h-72 rounded-xl">
                            <i className="ri-global-line text-3x lg:text-4xl my-3"></i>

                            <div className="card-text flex flex-col justify-center items-center">
                                <h1 className="head-text p-text text-xl font-bold">
                                    Payment Network
                                </h1>
                                <p className="description items-center text-gray-dark p-5 flex justify-center w-full text-center text-sm lg:text-base font-semibold">
                                    We have provided a precise payment network
                                    using smart contracts on the BNB blockchain,
                                    allowing users to transfer their assets
                                    securely with this established bridge. 🌐🔗
                                </p>
                            </div>
                        </div>

                        <div className="card how-it-works-bottom flex flex-col justify-around items-center bg-gray-dark h-72 rounded-xl">
                            <i className="ri-lock-password-line text-3x lg:text-4xl my-3"></i>

                            <div className="card-text flex flex-col justify-center items-center">
                                <h1 className="head-text p-text text-xl font-bold">
                                    Security & Scalable
                                </h1>
                                <p className="description items-center text-gray-dark p-5 flex justify-center w-full text-center text-sm lg:text-base font-semibold">
                                    Cash Reserve is a highly secure, scalable,
                                    and functional token with very low-cost
                                    transactions. By utilizing smart contracts
                                    on the BNB network, we have created a high
                                    level of security. With just a few simple
                                    clicks, you can transfer the required amount
                                    to your wallet in the shortest possible
                                    time. 🚀🔐
                                </p>
                            </div>
                        </div>

                        <div className="card how-it-works-right flex flex-col justify-around items-center bg-gray-dark h-72 rounded-xl">
                            <i className="ri-money-dollar-circle-line text-3x lg:text-4xl my-3"></i>

                            <div className="card-text flex flex-col justify-center items-center">
                                <h1 className="head-text p-text text-xl font-bold">
                                    Future Of Cash Reserve
                                </h1>
                                <p className="description items-center text-gray-dark p-5 flex justify-center w-full text-center text-sm lg:text-base font-semibold">
                                    Digital currencies will be an integral part
                                    of our lives in the future. We aim to have a
                                    significant share in the future of
                                    cryptocurrencies. We seek to establish
                                    connections with companies, industries,
                                    research groups, and scientific
                                    organizations, and we intend to be a
                                    currency with real-world applications.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

                <section
                    id="tokenomics"
                    className="flex flex-col justify-center items-center p-10"
                >
                    <div className="sections-top-text flex w-full justify-center flex-col items-center mb-5">
                        <h1 className="text-2xl md:text-3xl p-text">
                            Tokenomics
                        </h1>
                    </div>

                    <div className="cards grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 grid-flow-row">
                        <div className="tokenomics-top flex flex-col justify-center items-center p-6">
                            <span className="precents w-20 h-20 bg-yellow rounded-full flex justify-center items-center font-semibold text-xl">
                                10%
                            </span>
                            <p className="tokenomics-text tokentext-gray-dark w-full text-center text-base font-semibold">
                                10% of the total tokens will be offered for
                                presale, representing a significant share in the
                                Cash Reserve ecosystem. Naturally, this will be
                                the cheapest price to start investing. As early
                                buyers, you will have full voting rights and
                                influence over the future direction of Cash
                                Reserve. 💰🗳️🌟
                            </p>
                        </div>

                        <div className="tokenomics-top flex flex-col justify-center items-center p-6">
                            <span className="precents w-20 h-20 bg-yellow rounded-full flex justify-center items-center font-semibold text-xl">
                                5%
                            </span>
                            <p className="tokenomics-text text-gray-dark w-full text-center text-base font-semibold">
                                5% of the total tokens will be allocated as
                                rewards to loyal and long-term shareholders,
                                providing them with the opportunity to earn
                                passive income. 💼💰
                            </p>
                        </div>

                        <div className="tokenomics-top flex flex-col justify-center items-center p-6">
                            <span className="precents w-20 h-20 bg-yellow rounded-full flex justify-center items-center font-semibold text-xl">
                                5%
                            </span>
                            <p className="text-gray-dark w-full text-center text-base font-semibold">
                                5% for advertising campaigns, global marketing,
                                influencers, and famous individuals who
                                collaborate with and promote us. 🌍📢💫
                            </p>
                        </div>

                        <div className="tokenomics-bottom flex flex-col justify-center items-center p-6">
                            <span className="precents w-20 h-20 bg-yellow rounded-full flex justify-center items-center font-semibold text-xl">
                                20%
                            </span>
                            <p className="text-gray-dark w-full text-center text-base font-semibold">
                                20% of the three billion tokens produced will be
                                allocated to the developers. This is primarily
                                aimed at preventing severe fluctuations,
                                inflation, and ensuring the continued
                                development of Cash Reserve in the future. 🧑‍💼👩‍💼
                            </p>
                        </div>

                        <div className="tokenomics-bottom flex flex-col justify-center items-center p-6">
                            <span className="precents w-20 h-20 bg-yellow rounded-full flex justify-center items-center font-semibold text-xl">
                                20%
                            </span>
                            <p className="text-gray-dark w-full text-center text-base font-semibold">
                                20% will be allocated for lending to
                                international knowledge-based industries and
                                companies, contingent upon our experts' approval
                                as investments in their projects. The profits
                                generated from these investments will then be
                                distributed among the extensive community of
                                Cash Reserve holders through the growth of
                                financial value, thereby creating stability and
                                backing for it. 🌟🌐📈
                            </p>
                        </div>

                        <div className="tokenomics-bottom flex flex-col justify-center items-center p-6">
                            <span className="precents w-20 h-20 bg-yellow rounded-full flex justify-center items-center font-semibold text-xl">
                                40%
                            </span>
                            <p className="text-gray-dark w-full text-center text-base font-semibold">
                                The remaining 40% of the tokens will be
                                allocated for development on exchanges, listing,
                                and market offering in a controlled and gradual
                                manner. This is to protect the interests of the
                                Cash Reserve community, based on the insights of
                                our economic experts and planners. It will be
                                implemented over time according to the guidance
                                of specialized experts. 📈🌐💼
                            </p>
                        </div>
                    </div>
                </section>

                <section
                    id="roadmap"
                    className="relative roadmap w-full p-10 justify-center items-center flex"
                >
                    <div className="roadmap-main relative flex flex-col justify-center w-full mx-auto">
                        <div className="sections-top-text flex w-full justify-center flex-col items-center mb-5">
                            <h1 className="text-2xl md:text-3xl p-text">
                                Roadmap
                            </h1>
                        </div>

                        <div className="flex justify-center items-center w-full h-full p-10">
                            <span className="middle-line h-full hidden lg:block"></span>
                        </div>

                        <div className="w-full roadmap-cols grid grid-cols-2 justify-between">
                            <div className="roadmap-left left-side w-full hidden lg:block">
                                <div className="left-map relative flex justify-center items-center w-full">
                                    <div className="step-one left-map-content relative flex flex-col justify-center items-center w-10/12 bg-gray-light rounded-lg p-10">
                                        <h1 className="w-full text-start items-end justify-center text-xl mb-3 font-semibold">
                                            Step One: Start the Presale
                                        </h1>
                                        <p>
                                            To establish a minimum initial
                                            liquidity pool, increase the number
                                            of shareholders, and introduce Cash
                                            Reserve.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="roadmap-right right-side w-full right-0 hidden lg:block">
                                <div className="right-map relative flex justify-center items-center">
                                    <div className="step-two right-map-content relative flex flex-col justify-center items-center w-10/12 bg-gray-light rounded-lg p-10">
                                        <h1 className="w-full items-end justify-center text-start text-xl mb-3 font-semibold">
                                            Step Two: Establish and launch a
                                            bridge
                                        </h1>
                                        <p>
                                            Create and launch a secure and fast
                                            bridge between the BCS blockchain
                                            and Cash Reserve, ensuring
                                            compatibility and seamless transfer
                                            of assets.
                                            <br />
                                            Launch the Cash Reserve-related DEX.
                                            <br />
                                            Collaborate with influencers and
                                            individuals who can promote Cash
                                            Reserve.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="w-full roadmap-cols grid grid-cols-2 justify-between">
                            <div className="roadmap-left left-side w-full hidden lg:block">
                                <div className="left-map relative flex justify-center items-center w-full">
                                    <div className="step-three left-map-content relative flex flex-col justify-center items-center w-10/12 bg-gray-light rounded-lg p-10">
                                        <h1 className="w-full text-start items-end justify-center text-xl mb-3 font-semibold">
                                            Step Three: Listing on Major
                                            Exchanges
                                        </h1>
                                        <p>
                                            After completing the previous three
                                            steps, Cash Reserve will be listed
                                            on major exchanges worldwide. 🌍📈
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="roadmap-right right-side w-full right-0 hidden lg:block">
                                <div className="right-map relative flex justify-center items-center">
                                    <div className="step-four right-map-content relative flex flex-col justify-center items-center w-10/12 bg-gray-light rounded-lg p-10">
                                        <h1 className="w-full items-end justify-center text-start text-xl mb-3 font-semibold">
                                            Step Four: Native Ecosystem
                                        </h1>
                                        <p>
                                            Begin developing a secure, fast, and
                                            scalable native ecosystem and a
                                            dedicated exchange gateway.
                                            <br />
                                            Collaborate with research,
                                            investment companies, and research
                                            organizations.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="flex flex-col gap-10 justify-center items-center w-full lg:hidden">
                            <div className="flex justify-center items-center flex-col bg-gray-light p-7 rounded-lg">
                                <h1 className="w-full flex items-center justify-between text-start text-lg mb-3 font-semibold">
                                    Step One: Start the Presale
                                    <i class="ri-circle-fill completed m-step-one"></i>
                                </h1>
                                <p>
                                    To establish a minimum initial liquidity
                                    pool, increase the number of shareholders,
                                    and introduce Cash Reserve.
                                </p>
                            </div>

                            <div className="flex justify-center items-center flex-col bg-gray-light p-7 rounded-lg">
                                <h1 className="w-full flex items-center justify-between text-start text-lg mb-3 font-semibold">
                                    Step Two: Establish and Launch a Bridge
                                    <i class="ri-circle-fill completed m-step-two"></i>
                                </h1>
                                <p>
                                    Create and launch a secure and fast bridge
                                    between the BCS blockchain and Cash Reserve,
                                    ensuring compatibility and seamless transfer
                                    of assets.
                                    <br />
                                    Launch the Cash Reserve-related DEX.
                                    <br />
                                    Collaborate with influencers and individuals
                                    who can promote Cash Reserve. 🌐🔗💼
                                </p>
                            </div>

                            <div className="flex justify-center items-center flex-col bg-gray-light p-7 rounded-lg">
                                <h1 className="w-full flex items-center justify-between text-start text-lg mb-3 font-semibold">
                                    Step Three: Listing on Major Exchanges
                                    <i class="ri-circle-fill completed m-step-three"></i>
                                </h1>
                                <p>
                                    After completing the previous three steps,
                                    Cash Reserve will be listed on major
                                    exchanges worldwide. 🌍📈
                                </p>
                            </div>

                            <div className="flex justify-center items-center flex-col bg-gray-light p-7 rounded-lg">
                                <h1 className="w-full flex items-center justify-between text-start text-lg mb-3 font-semibold">
                                    Step Four: Native Ecosystem
                                    <i class="ri-circle-fill completed m-step-four"></i>
                                </h1>
                                <p>
                                    Begin developing a secure, fast, and
                                    scalable native ecosystem and a dedicated
                                    exchange gateway.
                                    <br />
                                    Collaborate with research, investment
                                    companies, and research organizations.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

                <footer
                    id="footer"
                    className="relative footer w-full flex flex-col justify-evenly items-center"
                >
                    <div className="footer-top socials text-2xl flex gap-8 pt-10 p-text my-10">
                        <a
                            href="https://x.com/CASHER_CR?t=r2nTJjmF8xvvekhYh2Pd3w&s=09"
                            target="_blank"
                        >
                            <i className="ri-twitter-x-line twitter"></i>
                        </a>
                        <a
                            href="https://www.instagram.com/cashreserve_casher?igsh=aTVscjlzbjIyaXJ2"
                            target="_blank"
                        >
                            <i className="ri-instagram-line instagram"></i>
                        </a>
                        <a href="https://t.me/cashreservecoin" target="_blank">
                            <i className="ri-telegram-2-line telegram"></i>
                        </a>
                    </div>

                    <div className="footer-bottom footer-menu menu w-10/12 my-10">
                        <ul className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 xl:grid-cols-7 list-none h-full gap-5 p-text">
                            <li>
                                <a href="#">Home</a>
                            </li>
                            <li>
                                <a href="#latest-news">Latest news</a>
                            </li>
                            <li>
                                <a href="#about-us">About us</a>
                            </li>
                            <li>
                                <a href="#how-it-works">How it works</a>
                            </li>
                            <li>
                                <a href="#tokenomics">Tokenomics</a>
                            </li>
                            <li>
                                <a href="#roadmap">Roadmap</a>
                            </li>
                            <li>
                                <a
                                    href="https://cashreservecasher.com/CashReserve-whitepaper.pdf"
                                    target="_blank"
                                >
                                    White paper
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div className="copyright">
                        <p>&copy; Cash Reserve | All right reserved</p>
                    </div>
                </footer>
            </div>

            <ToastContainer />
        </>
    );
}

export default App;
